import { call, put, takeLatest } from 'redux-saga/effects'
import { getParties } from '../../firebase-services/db-services';
import { getPartiesSuccess } from '../slices/partyState';
function* async_getPartyFetch() {
        
        const parties = yield call(()=>getParties());
        const formattedParty = yield parties.docs;
        //console.log({filter,Party})
        const PartyData = formattedParty.map(doc =>{
            return {...doc.data(),docid:doc.id}
        } )
        yield put(getPartiesSuccess(PartyData))
        
}
function* partySaga() {
    yield takeLatest('parties/getPartiesFetch', async_getPartyFetch);
}
export default partySaga;